import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { usePreferences } from "@/hooks/usePreferences";

const Index = () => {
  const navigate = useNavigate();
  const { user, loading } = useAuth();
  const { getOnboarded } = usePreferences();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    if (loading) return;

    const check = async () => {
      if (user) {
        const onboarded = await getOnboarded();
        navigate(onboarded ? "/home" : "/onboarding", { replace: true });
      } else {
        navigate("/landing", { replace: true });
      }
      setChecking(false);
    };
    check();
  }, [user, loading, navigate, getOnboarded]);

  return null;
};

export default Index;
